import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Prime Markets - Premium Trading Platform",
  description = "Trade Forex, Stocks, Indices, Commodities and Crypto with Prime Markets. Professional trading platform with competitive spreads, advanced tools, and expert support.",
  keywords = "forex trading, stocks, CFD trading, commodities, crypto trading, trading platform, Prime Markets",
  image = "https://factsheets.digitallandscape.co.za/site/images/PrimeMarkets-premium-trading.png",
  url = "https://primemarkets.co.za",
  type = "website",
  structuredData = null
}) => {
  const fullTitle = title.includes('Prime Markets') ? title : `${title} | Prime Markets`;
  const fullUrl = url.startsWith('http') ? url : `https://primemarkets.co.za${url}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Prime Markets" />
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content="Prime Markets" />
      <meta property="og:locale" content="en_ZA" />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@primemarkets" />
      <meta name="twitter:creator" content="@primemarkets" />
      
      {/* Additional SEO Meta Tags */}
      <meta name="geo.region" content="ZA" />
      <meta name="geo.placename" content="South Africa" />
      <meta name="language" content="English" />
      <meta name="distribution" content="global" />
      <meta name="rating" content="general" />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;